@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

#designOverlay {
  height: 410px;
}

.ciDesign {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: $spacing-16;

  &-lab {
    &-laptop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 420px;
      height: 270px;
      width: 45%;
      @include image('assets/header/lab_laptop.png');
    }

    &-mega {
      width: 530px;
      padding-right: $spacing-16;

      &-heading {
        padding: 0;
        margin: 0;
      }

      &-description {
        font-size: $typography-body-long2-size;
        line-height: $typography-line-height;
      }
    }

    &-button {
      display: flex;
      justify-content: right;
      padding-top: 15px;
    }
  }

  &-mega-images {
    display: flex;
    justify-content: space-around;
    text-align: center;
    font-size: $typography-caption-caption-regular-size;
  }
}

@include breakpoint('xl') {
  .ciDesign {
    &-lab {
      &-mega {
        width: 710px;
        padding-right: $spacing-32;
      }
    }
  }
}
